/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Uswitch } from '../providers/providers'
import ModalPopupLink from './moreInfoButton'
import Grid from '../helpers/grid'
const WinnersCard = ({
  awardLabel,
  awardTitle,
  winnersLogo,
  providerName,
  modalContent,
  ctaText,
  ctaHref
}) => (
  <div
    sx={{
      background: 'white',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
      borderRadius: '8px',
      width: 'min(815px, 100%)',
      m: '0 auto',
      overflow: 'hidden'
    }}
  >
    <div sx={{ paddingTop: 24, paddingX: 24 }}>
      {awardLabel}
      <div sx={{ marginTop: 32 }} />
      <Grid gridTemplateColumns={'1.3fr 1fr'}>
        <div
          sx={{
            display: 'flex',
            flexDirection: ['column', 'row'],
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            borderRight: 'solid 1px #E3E3E3',
            mr: [0],
            pr: [16, 32]
          }}
        >
          <div sx={{ mr: 16 }}>
            <Uswitch />
          </div>

          <div
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            <div
              sx={{
                fontWeight: 500,
                fontSize: ['18px', '24px', '24px'],
                lineHeight: '32px',
                color: '#141414'
              }}
            >
              <p sx={{ m: 0 }}>{awardTitle}</p>
              <p sx={{ m: 0, fontWeight: 700 }}>Winner 2024</p>
            </div>
          </div>
        </div>
        <div sx={{ pl: 0 }}>{winnersLogo}</div>
      </Grid>
    </div>

    <div
      sx={{
        mt: ['16px', '32px'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        flexWrap: 'wrap',
        gap: ['16px', '36px'],
        height: ['120px', '80px'],
        backgroundColor: '#F3F3F3'
      }}
    >
      <ModalPopupLink
        text={`Why ${providerName} won`}
        modalContent={modalContent}
      />

      {!!ctaHref && !!ctaText && (
        <a
          href={ctaHref}
          target="_blank"
          rel="noreferrer"
          sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            px: 12,
            height: 48,
            border: '1px solid black',
            borderRadius: '2px',
            background: '#FFF',
            fontWeight: 700
          }}
        >
          {ctaText}
        </a>
      )}
    </div>
  </div>
)

export default WinnersCard
